import { combineReducers } from 'redux'

import dietCategoryReducer from './diet-category-reducer'
import dietReducer from './diet-reducer'
import dietsAndDietCategoriesReducer from './diets-and-diet-categories-reducer'

export default combineReducers({
  dietsAndDietCategories: dietsAndDietCategoriesReducer,
  dietCategory: dietCategoryReducer,
  diet: dietReducer,
})
